const ConsentChannels = Object.freeze({
  PUSH: 'push',
  EMAIL: 'email',
  SMS: 'sms'
})

export { ConsentChannels }



// WEBPACK FOOTER //
// ./src/modules/profiles/enum/ConsentChannelEnum.js